<template>
    <div>
        <alert
            :variant="alert.variant"            
            dismissible
            :mensagens="alert.mensagens"
            :value="alert.exibir"
            @input="alertDismissed">
        </alert>
        <b-row class="pb-2"> 
            <b-col class="text-right">                                                   
                    <b-btn size="sm" 
                           variant="outline-secondary"  
                           @click="novo"
                           v-if="acao != 'view'"
                           :disabled="!idAto">
                        <i class="fa fa-file-o pr-1"></i> Novo Anexo
                    </b-btn>                             
            </b-col>               
        </b-row>   
        <b-row>
            <b-col>
                <b-table 
                    no-provider-paging 
                    small     
                    ref="tableAnexos"                                              
                    :current-page="tabela.currentPage"
                    :empty-text="tabela.emptyText"
                    :fields="tabela.fields"                                                               
                    :items="tabela.items"
                    :per-page="tabela.perPage"    
                    :show-empty="tabela.showEmpty"
                    :striped="tabela.striped"
                >   
                    <template v-slot:cell(documento_anexo_ato.nome_original)="data">
                        <b-input-group>             
                            <b-form-file      
                                @input="inputAnexo(data.item)"                            
                                :accept="extPermitidas.toString()" 
                                :placeholder="placeholderArquivo(data.item.documento_anexo_ato.nome_original)" 
                                v-model="data.item.arquivo" 
                                :disabled="acao == 'view' || !!data.item.id"   
                                size="sm" 
                                ref="anexoInput"                                
                              >
                            </b-form-file>
                        </b-input-group>                                 

                    </template>
                    
                    <template v-slot:cell(exibir)="data" >                                   
                        <b-link 
                            class="fa fa-file-o fa-lg icon-doc"                             
                            v-if="(data.item.anexo_ato_documento_id != null)" 
                            @click="$helper.exibirAnexo($env.VUE_APP_URL_API,data.item)">
                        </b-link>
                    </template>   
                      
                    <template v-slot:cell(excluir)="data" >                                   
                        <b-link 
                            class="fa fa-trash fa-lg" 
                            v-if="acao != 'view'"
                            @click="excluir(data.item)">
                        </b-link>
                    </template>
                </b-table>
            </b-col>    
        </b-row>
        <b-row align-h="end">
            <b-col class="col-md-4">
                <b-form-group                       
                    label-cols="8"
                    label="Itens por página:"
                    label-align="right"
                    label-size="sm"   
                    label-class="mt-1 text-secondary"                                                                                                                                                        
                >                        
                    <b-form-select 
                        v-model="tabela.perPage"
                        size="sm"
                        :options="tabela.pageOptions"
                        @change="tabela.currentPage=1"                            
                        >
                    </b-form-select>
                </b-form-group> 
            </b-col>
            <b-col cols="3">
                <b-pagination v-show="tabela.items.length > tabela.perPage" align="right"
                    :total-rows="tabela.items.length" 
                    :per-page="tabela.perPage" 
                    :value="tabela.currentPage"                  
                    @change="mudaPagina" 
                    class="mt-2" 
                    size="sm"
                >
                </b-pagination>
            </b-col>
        </b-row>   
    </div>      
</template>

<script>

import Alert from '../../../models/Alert'
import AnexoAto from '../../../models/AnexoAto'

export default {


    props: {
        idAto: { type: Number },        
        acao: {type: String, default: ''}
    },

    data(){
        return {   
            tabela:{
                currentPage: 1,                
                emptyText:'Nenhum registro encontrado',
                fields: [                 
                    {
                        key: 'documento_anexo_ato.nome_original',
                        label: 'Anexo',
                        sortable: true, 
                        class: 'text-center',                                                                                                                                                             
                    }, 
                    {
                        key: 'exibir',
                        label: '',  
                        class: 'text-center',                                             
                    },  
                    {
                        key: 'excluir',
                        label: '',  
                        class: 'text-center',                                            
                    },   
                                   
                ],  
                items: [],              
                perPage: 10,
                showEmpty: true,
                striped: true,
                pageOptions: [10, 25, 50],                                              
            },
            alert: new Alert(),                      
            indiceAnexoSelecionado:0,  
            extPermitidas: [".pdf", ".doc", ".docx", ".rtf", ".xls", ".xlsx", ".txt"]
        }
    },


    methods: {

        placeholderArquivo(nome_original){            
            return nome_original  == null ? 'Clique para selecionar/alterar documento' : nome_original;
        },
        
        alertDismissed(){           
            this.alert = new Alert();
        },

        mudaPagina(pagina) {
            this.tabela.currentPage = pagina;                    
        },

        listar(){                          
            this.$api.anexoAto.listar(this.idAto)
                .then(response => { 
                        this.tabela.items = [];                                    
                        response.data.data.forEach(element => {  
                            let anexoAto = new AnexoAto(element);                                                                           
                            this.tabela.items.push(anexoAto); 
                        });                                                                            
                })
                .catch(error => {           
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);                                         
                });                                 
        },

        novo(){
            let anexo = new AnexoAto();    
            let maxOrdemAnexo = 0;
            
            anexo.ato_id = this.idAto,   
            
            maxOrdemAnexo = this.tabela.items.length > 0 ? Math.max.apply(Math, this.tabela.items.map(function(o) { return o.ordem_anexo; })) : 0;            
            anexo.ordem_anexo = maxOrdemAnexo + 1;                     

            this.tabela.items.push(anexo);  
        },

        
        async incluir(anexo){                     
            let params = {}
            params.ordem_anexo = anexo.ordem_anexo;
            params.nome_arquivo = anexo.arquivo.name;
          
            await this.$helper.convertToBase64(anexo.arquivo)
            .then(response => {                    
                params.arquivo= response;      
            })              
            .catch(error => {           
                this.alert = {
                    variant: 'danger',
                    mensagens: 'Erro ao converter anexo para base64: ' + error.response.data.errors,
                    exibir:true                     
                };    
            });             
 
            this.$api.anexoAto.incluir(this.idAto, params)
                .then(response => {                    
                    if(response.status == 200 || response.status == 201){                                                
                        this.tabela.items[this.indiceAnexoSelecionado]  = new AnexoAto(response.data.data);              
                        this.$refs.tableAnexos.refresh();                           
                        this.$helper.showAlert(this.alert, 
                                               this.$constantes.alert.variants.SUCCESS,
                                               'Registro inserido com sucesso!');                                                                                    
                    }             
                })
                .catch(error => {             
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);                                                              
                });        
        },

        verificaTamanhoArquivoAnexoValido(arquivo){                                             
            if(arquivo.size > this.$constantes.documentos.TAMANHO_LIMITE_UPLOAD_ANEXO_ATO){   
                this.$helper.showAlert(this.alert, 
                                       this.$constantes.alert.variants.WARNING,
                                       `Tamanho máximo do arquivo deve ser de ${this.$helper.bytesToSize(this.$constantes.documentos.TAMANHO_LIMITE_UPLOAD_ANEXO_ATO)}.`);  
                return false; 
            }
            return true;        
        },

        inputAnexo(anexo){
            if(anexo.arquivo){
                
                if(!this.$helper.validaExtensaoArquivo(anexo.arquivo.name, this.extPermitidas)){
                    this.$helper.showAlert(this.alert, 
                                        this.$constantes.alert.variants.WARNING,
                                        'Extensão do arquivo não suportada. Escolha arquivos com as extensões: ' +  this.extPermitidas.toString());  
                    this.$refs.anexoInput.reset();                  
                    return;                    
                }

                if(!this.verificaTamanhoArquivoAnexoValido(anexo.arquivo)){
                    this.$refs.anexoInput.reset();                  
                    return;
                }

                this.indiceAnexoSelecionado = this.tabela.items.findIndex(a => {
                    return a.ordem_anexo === anexo.ordem_anexo;
                });                         

                this.incluir(anexo);                
            }
        },

        remove(ordemAnexo) {
            var indice = this.tabela.items.findIndex(a => {
                return a.ordem_anexo === ordemAnexo;
            });

            this.tabela.items.splice(indice, 1);            
        },

        excluir(anexo){                      
            //CASO TENHA NO BANCO, FAZ REQUISIÇÃO E EXCLUI   
            if(anexo.id) {  
                let message = `Confirma a exclusão do anexo "${anexo.documento_anexo_ato.nome_original}"?`;

                this.$helper.confirmaExclusao(this, message)
                    .then(value => {
                        if(value){ 
                            this.$api.anexoAto.excluir(anexo.id)
                                .then(response => {                    
                                    if(response.status == 200 || response.status == 201){
                                        this.remove(anexo.ordem_anexo);                                                                    
                                        
                                        this.$helper.showAlert(this.alert, 
                                                               this.$constantes.alert.variants.SUCCESS,
                                                               'Anexo excluído com sucesso!');                                    }
                                })
                                .catch(error => {              
                                        this.$helper.showAlert(this.alert, 
                                                               this.$constantes.alert.variants.DANGER,
                                                               error.response.data.errors);
                                });   
                        }
                    });             
            }else{
                //CASO NÃO TENHA, SÓ RETIRA DO OBJETO
                this.remove(anexo.ordem_anexo);          
            }                        
        }  
        
    },

    watch: {
        idAto: function () {
            if(this.idAto){
                this.listar();
            }
        },
    },

}
</script>

<style scoped>
    .fa-trash {
        color: #dc3545;
    }

    .icon-doc{
        color: #6c757d;;
    }

</style>
